import React from 'react'
import AALSnippet from './annotation/AALSnippet'
import { useAppDispatch } from '../store/hooks'
import { AnnotationDataBoundingBox } from '../types/models/annotation'
import { setSelectedBoundingBox } from '../store/slices/annotationSlice'

interface SnippetWithOverlayProps {
  contentId: string
  bbox: AnnotationDataBoundingBox
  isSelected: boolean
  projectAnnotationType: string
  rotateLongSideVertical?: boolean
}

const SnippetWithOverlay: React.FC<SnippetWithOverlayProps> = ({
  contentId,
  bbox,
  isSelected,
  projectAnnotationType,
  rotateLongSideVertical = false,
}) => {
  const dispatch = useAppDispatch()
  const handleClick = () => {
    dispatch(setSelectedBoundingBox(bbox))
  }
  return (
    <div className="position-relative ratio ratio-1x1">
      {(projectAnnotationType === 'bounding_box' ||
        projectAnnotationType === 'oriented_bounding_box') && (
        <div className="position-absolute top-0 start-0 w-100 h-100" onClick={handleClick}>
          <AALSnippet
            contentId={contentId}
            bbox={bbox}
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              cursor: 'pointer',
              border: isSelected ? '3px solid #6f42c1' : '1px solid #333',
              backgroundColor: 'transparent',
            }}
            rotateLongSideVertical={rotateLongSideVertical}
          />
        </div>
      )}
    </div>
  )
}

export default SnippetWithOverlay
